// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__yoS6W"};